// Services
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";
import breedService from "@/app/services/main/breed/breed-service.js";

const MatingDamSireDetails = () =>
    import(/*webpackChunkName: "mating-dam-sire-details-container" */ "@/app/views/main-view/breeding-management/puppy-management/containers/litter-list-container/components/mating-dam-sire-details-container/mating-dam-sire-details-container.vue")


// Mixins
import { dateMixins } from "@/app/mixins/utils/date-mixins";
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins";
import { unsavedChangesModalMixins } from "@/app/mixins/utils/unsaved-changes-mixins.js";
import { imageCompressorMixins } from "@/app/mixins/utils/image-compressor-mixins"

// Components
const InputWeightProgressionTable = () => import(/* webpackPrefetch: true, webpackChunkName: 'input-weight-progression-table' */ "@/app/views/main-view/breeding-management/puppy-management/components/input-weight-progression-table/input-weight-progression-table.vue");

// Constants
import { STATUS_CODES, SUCCESS_MSG, LITTER_STATUS} from "@/app/constants/status-constants";
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';
import PUPPY_CARE_INFO from "@/app/views/main-view/breeding-management/gestation-period/constants/puppy-care.info.js";

// Third Party libraries
import DatePicker from "vue2-datepicker";
import { Bar } from 'vue-chartjs/legacy';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
} from 'chart.js'
  
ChartJS.register(Title, Tooltip, Legend, CategoryScale, BarElement, LinearScale);

export default {
    name: "EditLitterContainer",
    components: { DatePicker, Bar, MatingDamSireDetails, InputWeightProgressionTable },
    mixins: [ 
        imageCompressorMixins,
        dateMixins, 
        toastMessageMixins, 
        unsavedChangesModalMixins
    ],
    data() {
        const initialChartDataLabels = [
            "Birth Weight",
        ]

        return {
            isAPILoading: true,
            isAPISubmitLoading: false,
            matingId: null,
            litterId: null,

            breedList: [],

            matingDetails: null,
            littersCount: 0,
            matingName: "",
            damDetails: null,
            sireDetails: null,

            genderOption: ["Male", "Female"],

            puppyNotes: "",
            puppyNotesHistory: [],
            initialPuppyNotes: "",

            puppyList: [],
            initialPuppyList: [],

            initialWeightTrackerList: [],
            windowWidth: window.innerWidth,

            breed: {},

            maxWeight: 99999.99,
            maxPuppiesCount: 15,

            isSavingLittersSuccess: false,
            prevRoute: "Puppy List",
            prevRouteTo:'',
            isPuppyImageLoading: false,
            isNewPuppyImage: false,
			isNewForm: false,
			isDuplicate: false,

            // Images
			imageRef: [],
			imageSrc: [],
			fileBlob: null,
			filesToSend: [],
			setAsPrimary: 0,
			updatedImages: [],
			deletedImages: [],
            imageTypeList: ['image/svg','image/png','image/jpg','image/jpeg','image/gif','image/raw', 'image/webp'],
            initialImageSrc: [],
            initialPrimaryImage: null,
            
            weightTrackerList: {
                birthWeight: {},
                periods: {
                    weekOne: {
                        title: "Week One",
                        data: [],
                        notBeforeThisDate: null,
                        notAfterThisDate: null,
                    },
                    weekTwo: {
                        title: "Week Two",
                        data: [],
                        notBeforeThisDate: null,
                        notAfterThisDate: null,
                    },
                    progression: {
                        title: "Progression",
                        data: [],
                        notBeforeThisDate: null,
                        notAfterThisDate: null,
                    },
                }
            },
            whelpDate: null,
            defaultDateOfBirth: null,
            weightTrackerListToDelete: [],
            progressionPercentage: [new Array(7), new Array(7), []],
            weightProgressionPercentage: [],
            initialChartDataLabels,
            maxNumEntries: 14,
            chartData: {
                labels: initialChartDataLabels,
                datasets: [
                    {
                        label: "",
                        data: [],
                        backgroundColor: new Array(16).fill("#25BF53"), 
                    },
                ],
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: {
                        stacked: true,
                        display: true,
                        title: {
                          display: true,
                          text: 'Day',
                          font: {
                              size: 18,
                              weight: "bold",
                          },
                        }
                      },
                    y: {
                        stacked: true,
                        display: true,
                        title: {
                          display: true,
                          text: 'Weight (kg)',
                          font: {
                              size: 18,
                              weight: "bold",
                          },
                          padding: 18
                        }
                    },
                },
                plugins: {
                    legend: {
                      display: false, 
                    },
                    title: {
                        display: true, 
                        text: "Puppy Weight Progression", 
                        font: {
                            size: 20, 
                            weight: "bold",
                        },
                        padding: {
                            bottom: 25,
                            top: 25,
                        },
                        align: "center",
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const value = context.raw ? parseFloat(context.raw) : context.raw;
                                return `${value} kg`;
                            }
                        }
                    },
                },
            },
            typeOfBirth: null,

            PUPPY_CARE_INFO,
            isPuppyCareInfoExpanded: false,
        };
    },
    computed: {
        showUploadButton() {
			return (
				this.imageSrc.length < 7
			)
		},
        allowUpdateOfImages() {
			return (
				(!this.isNewForm && (this.matingDetails.status === "ACTIVE"))
			)
		},
        graphWidth() {
            let width = null; // will let the library handle the default width
            if (this.windowWidth <= 767) {
                width = 200;
            }

            return width;
        },
    },
    async created() {

        if (this.$route.query) {
            this.matingId = this.$route.query.id;
            this.litterId = this.$route.query.litterId;

            try{
                this.isAPILoading = true;

                await this.getBreedList();
                await this.getDamAndSireMatingDetails(this.$route.query.id, this.$route.query.litterId);
            } catch(err){
                this.showGenericErrorToast();
            } finally{
                this.isAPILoading = false;
            }

            if(this.$route.query.from === "mating-details"){
                this.prevRoute = "Mating Details";
            } else {
                
                this.prevRouteTo = `${BREEDER_ROUTES.LITTER_LIST}?id=${this.matingId}&from=litter-management`
            }
        }
    },
    watch: {
        weightTrackerList: {
            immediate: true,
			deep: true,
			handler(newValue) {
				if (newValue) {
                    const weightList = newValue;

                    // ************** computing the weight progress for each period (weeks) ************** //
                    Object.keys(weightList.periods).forEach((periodKey, periodIndex, periodsArr) => {
                        const currentPeriod = weightList.periods[periodKey];

                        const prevPeriodKey = periodsArr[periodIndex - 1];
                        const prevPeriod = prevPeriodKey ? weightList.periods[prevPeriodKey] : null;

                        currentPeriod.data.forEach((currentEntry, entryIndex, arr) => {
                            // get previous values of the current entry, only get the values with data
                            const prevValues = arr.slice(0, entryIndex).filter((entity) => parseFloat(entity.weight));
                            let prevEntry = prevValues[prevValues.length - 1]; // fetch the previous most entry with data

                            // consider the birthWeight if the current week is week one (for the first day)
                            if (periodKey === "weekOne" && entryIndex === 0) {
                                prevEntry = weightList.birthWeight;
                            } else if (entryIndex === 0){
                                // get the last entry on the previous period or week
                                prevEntry = prevPeriod ? prevPeriod.data[prevPeriod.data.length - 1] : null;
                            }

                            if (prevEntry) {
                                // percentage computation
                                const previousValue = parseFloat(prevEntry.weight || 0);
                                const currentValue = parseFloat(currentEntry.weight || 0);

                                if (currentValue) {
                                    // Update the progression percentage at the correct period and entry index
                                    const percentage = this.computePercentageDifference(previousValue, currentValue);

                                    // Ensure reactivity by using $set for both period and entry
                                    this.$set(this.progressionPercentage[periodIndex], entryIndex, percentage);
                                
                                    // Update the chart data
                                    this.chartData.datasets[0].data[entryIndex] = currentEntry.weight || 0;
                                } else {
                                    // If no current value, set the progression percentage to 0
                                    this.$set(this.progressionPercentage[periodIndex], entryIndex, 0);
                                }
                            }
                        });

                    });

                    // ************** setting the inputted weight values (and bg colors) in the graph and its x-axis date values ************** //

                    this.chartData.labels = JSON.parse(JSON.stringify(this.initialChartDataLabels)); // deep clone to remove its reference from the object initialChartDataLabels
                    this.chartData.datasets[0].data = [];

                    const periodData = Object.values(weightList.periods)
                        .map((period) => period.data)
                        .flat();
                    const allWeightInputs = [weightList.birthWeight, ...periodData];

                    allWeightInputs.forEach((currentEntry, index, arr) => {
                        this.chartData.datasets[0].data[index] = currentEntry.weight || 0;
                        this.chartData.datasets[0].data = [...this.chartData.datasets[0].data]; // force rerender of graph

                        // get previous values of the current entry, only get the values with data
                        const prevValues = arr.slice(0, index).filter((entity) => parseFloat(entity.weight));
                        const prevEntry = prevValues[prevValues.length - 1]; // fetch the previous most entry with data

                        if (prevEntry) {
                            // display the current entry with red if it's less than the entry (with data) before it
                            if (prevEntry.weight && parseFloat(currentEntry.weight || 0) < parseFloat(prevEntry.weight || 0)) {
                                this.chartData.datasets[0].backgroundColor[index] = "red";
                            } else {
                                this.chartData.datasets[0].backgroundColor[index] = "#25BF53";
                            }
                        }

                        // exclude index 0 (birth weight) for formatting the dates in the x-axis of the graph
                        if (index > 0) {
                            this.chartData.labels[index] = this.formatDate(currentEntry.entry);
                        }
                    });

                }
			}
        }
    },
    methods: {
        redirectToPublish() {
            this.$router.push(`/puppy-sales/sell-your-puppy-info?litterId=${this.litterId}&matingId=${this.matingId}`)
        },
        setPrimaryPhoto(index, image) {
			const isNewImage = !image.id //Newly added image
			if (isNewImage) {
				if (this.isNewForm && !this.isDuplicate) {
					//New form
					this.imageRef[this.setAsPrimary].primary = false
					this.imageRef[index].primary = true
					this.updatedImages = []
				} else if (this.isNewForm && this.isDuplicate) {
					const ctr = this.imageSrc.length - index
					const imageRefIdx = this.imageRef.length - ctr
					this.resetPrimaryPhoto("imageRef")
					this.imageRef[imageRefIdx].primary = true
					this.resetPrimaryPhoto("copiedImages")
				} else {
					//Update form
					const ctr = this.imageSrc.length - index
					const imageRefIdx = this.imageRef.length - ctr

					this.resetPrimaryPhoto("imageRef")
					this.imageRef[imageRefIdx].primary = true
					this.updatedImages = []
				}
			} else {
				//Check if the form is a duplicate copy
				if (!this.isDuplicate) {
					if (this.updatedImages.length === 0) {
						//Reset all newly added images to primary false
						this.resetPrimaryPhoto("imageRef")

						//Insert the new primary photo to updatedImages
						this.updatedImages.push({ ...this.imageSrc[index], primary: true })
					} else {
						//Reset all newly added images to primary false
						this.resetPrimaryPhoto("imageRef")

						this.updatedImages = []
						//Insert the new primary photo to updatedImages
						this.updatedImages.push({ ...this.imageSrc[index], primary: true })
					}
				} else {
					this.resetPrimaryPhoto("imageRef")
					this.resetPrimaryPhoto("copiedImages")
					this.copiedImages[index].primary = true
				}
			}
		},
        resetPrimaryPhoto(images) {
			if (this[images].length != 0) {
				this[images] = this[images].map((img) => {
					return {
						...img,
						primary: false,
					}
				})
			}
		},
        async onUploadImage(event) {
			this.isNewPuppyImage = true
			// Change Object of images to Array
			const images = Object.values(event.target.files)

            this.fileBlob = images

			// Throw Error when uploaded images is more than 7
			if (images.length > 7 || this.imageSrc.length > 7 || this.imageSrc.length + images.length > 7) {
				this.showCustomErrorToast("Error", "Unable to upload more than 7 images.")
				return
			}
			
			this.fileBlob.forEach(async (file, idx) => {
				let valid  = await this.validateImageWithType(file, this.imageTypeList);
                
				if ( valid ) {
					let reader = new FileReader()
					reader.readAsDataURL(file)
	
					let primary = false
					if (this.isNewForm && !this.isDuplicate) {
						if (this.filesToSend.length === 0 && idx === 0) {
							primary = true
						}
					} else {
						if (this.imageSrc.length === 0 && idx === 0) {
							primary = true
						}
					}
	
					reader.onload = async () => {
						// Push images to an array and display with imageSrc
						if (this.imageSrc.length <= 7) {
							await this.imageSrc.push(reader.result)
							await this.filesToSend.push(file)
							await this.imageRef.push({ primary, name: file.name })
						} else {
							return
						}
					}
				}
			})
		},
        async onSubmitDetails(){
            try{
                this.isAPISubmitLoading = true;
                const littersWithValues = this.puppyList.filter((puppy) => {
                    const { gender, identifyingMarks, collarColour, puppyName, dateOfBirth, birthWeight, microchipNumber } = puppy;
                    if (
                        gender ||
                        (identifyingMarks && identifyingMarks.trim()) ||
                        (collarColour && collarColour.trim()) ||
                        (puppyName && puppyName.trim()) ||
                        this.breed ||
                        dateOfBirth ||
                        birthWeight ||
                        microchipNumber
                    ) {
                        return true;
                    }

                    return false;
                });

                if (littersWithValues.length === 0) {
                    await this.$swal({
                        text: "Please fill out litter details.",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });

                    return;
                }

                // Display error validations for entries with missing dates or weights
                for (const [periodKey, currentPeriod] of Object.entries(this.weightTrackerList.periods)) {
                    if (currentPeriod && currentPeriod.data) {
                        const entriesWithEmptyWeights = currentPeriod.data.filter(({ id, weight }) => id && parseFloat(weight || 0) === 0).map(({ id }) => id);
                        this.weightTrackerListToDelete = [...this.weightTrackerListToDelete, ...entriesWithEmptyWeights];

                        currentPeriod.data = currentPeriod.data
                            .filter(({ weight }) => parseFloat(weight || 0) > 0) // Only keep entries with a weight
                            .map(({ entry, weight, ...rest }) => ({
                                entry,
                                weight: weight != null ? weight : 0,
                                isError: !entry, // Mark as error if entry is missing (shouldn't happen due to the filter)
                                ...rest,
                            }));
                    }
                }

                const areSomeDatesEmpty = Object.values(this.weightTrackerList.periods)
                    .map((period) => period.data)
                    .flat()
                    .some((data) => Boolean(data.isError));

                if (areSomeDatesEmpty) {
                    return;
                }

                const littersToSave = this.puppyList.map((puppy) => {
                    const { id, gender, identifyingMarks, collarColour, puppyName, dateOfBirth, matingId, status, microchipNumber, waitlistStatus } = puppy;

                    const updatedWeightTracker = Object.entries(this.weightTrackerList.periods).reduce((acc, [periodKey, currentPeriod]) => {
                        const periodData = currentPeriod.data.map((entryObj) => {
                            return {
                                period: periodKey,
                                id: entryObj.id === "" ? null : entryObj.id,
                                litterId: this.litterId,
                                status: entryObj.status,
                                weight: entryObj.weight === "" ? null : parseFloat(entryObj.weight),
                                unitsOfWeight: entryObj.unitsOfWeight.toLocaleLowerCase(),
                                entry: this.dateToISO(entryObj.entry),
                            };
                        });

                        acc.push(periodData);

                        return acc;
                    }, []);

                    const birthWeight = this.weightTrackerList.birthWeight.weight;

                    const payload = {
                        id,
                        matingId,
                        breedId: this.breed ? this.breed.id : null,
                        name: puppyName,
                        status: status === 'PUBLISHED' ? 'PUBLISHED' : LITTER_STATUS.ACTIVE,
                        dateOfBirth: dateOfBirth ? this.dateToISO(dateOfBirth) : null,
                        identifyingMarks,
                        collarColour,
                        birthWeight: birthWeight ? birthWeight : null,
                        unitsOfWeight: "kg",
                        gender,
                        breederSysId: this.matingDetails.breederSysId,
                        imageRef: this.imageRef, //Image reference of the newly added photo
                        updatedImages: this.updatedImages, //New primary photo
                        deletedImages: this.deletedImages, //Images to be deleted in the database
                        weightTracker: updatedWeightTracker.flat(),
                        weightTrackerListToDelete: this.weightTrackerListToDelete,
                        microchipNumber,
                        waitlistStatus
                    };

                    return payload;
                });

                const tmpImages =  this.filesToSend.length ? await this.compressMultipleImages(this.filesToSend): []
                const puppyDetails = {
                    formData: { ...littersToSave[0], note: this.puppyNotes },
                    images: tmpImages,
                };

                const littersSavingResponse = await breedingManagementService.saveLitterPuppyDetails(this.litterId, puppyDetails);

                if (littersSavingResponse.status !== STATUS_CODES.SUCCESS) {
                    await this.$swal({
                        html: "<span>An error occurred while saving the added puppies. <br> <strong>Please try saving again.</strong> </span>",
                        imageHeight: "30px",
                        imageUrl: `${require("@/assets/images/_shared/sad-dog.png")}`,
                        imageAlt: "Sad Dog",
                        confirmButtonText: "Got it",
                        showCloseButton: true,
                    });
                } else {
                    const { SUCCESS_UPDATE_LITTER } = this.toastMessages.litters();
                    this.showCustomSuccessToast(SUCCESS_MSG.SUCCESS_TITLE, SUCCESS_UPDATE_LITTER);
                }

                // get the data return back by POST to have the saved values with IDs in order to differentiate them from the new data
                if (littersSavingResponse && littersSavingResponse.data && !littersSavingResponse.data.errors) {
                    this.puppyList = [];
                    this.initialPuppyList = [];
                    this.puppyList.push(littersSavingResponse.data);

                    const details = {
                        birthWeight: littersSavingResponse.data ? littersSavingResponse.data.birthWeight : 0,
                        dateOfBirth: littersSavingResponse.data.dateOfBirth,
                        weightTracker: littersSavingResponse.data.weightTracker,
                    };

                    this.populateWeightTrackerList(details, true);

                    this.puppyList = this.puppyList.map((puppy) => {
                        const { dateOfBirth, breedId, name } = puppy;
                        this.breed = breedId ? this.breedList.find((breedItem) => breedItem.id === breedId) : null;

                        return {
                            ...puppy,
                            puppyName: name,
                            breed: this.breed,
                            dateOfBirth: dateOfBirth ? new Date(dateOfBirth) : null,
                        };
                    });

                    this.puppyList[0].images.forEach((img, i) => {
                        if (img.primary) {
                            this.setAsPrimary = i;
                        }
                    });

                    // notes
                    const noteHistory = littersSavingResponse.data.litterNoteHistory;
                    if (noteHistory && noteHistory.length > 0) {
                        this.puppyNotesHistory = noteHistory.filter((noteData) => noteData.note !== "");
                        this.puppyNotes = noteHistory[0].note;
                    }

                    this.chartData.datasets[0].data = [...this.chartData.datasets[0].data]; // this is needed to force the chart to rerender

                    // deep copy
                    this.initialPuppyList = JSON.parse(JSON.stringify(this.puppyList));
                    this.imageSrc = this.puppyList[0].images;
                    this.imageRef = [];
                    this.filesToSend = [];

                    this.initialImageSrc = JSON.stringify(this.imageSrc);
                    this.initialPuppyNotes = this.puppyNotes;

                    const foundInitialImg = this.puppyList[0].images.find(imageData => imageData.primary);
                    this.initialPrimaryImage = foundInitialImg ? JSON.parse(JSON.stringify(foundInitialImg)) : null;
                    this.deletedImages = [];
                } else if (littersSavingResponse.data.errors) {
                    this.showCustomErrorToast("Invalid file format", littersSavingResponse.data.errors[0].message);
                }
            } catch(err){          
                this.showGenericErrorToast();
                
            } finally{
                this.isAPISubmitLoading = false;
            }
        },
        onChangeDateOfBirth(dateOfBirth){
            let dateOfBirthCopy = new Date();  // fallback to get current date

            if(dateOfBirth){
                dateOfBirthCopy = new Date(dateOfBirth); 
                dateOfBirthCopy.setDate(dateOfBirth.getDate() + 1); // add 1 to exclude the DOB on the first day datepicker
            }

            // only pass the dateOfBirth value since the periods (weeks) will use it for checking the enabled dates on the datepickers
            this.populateWeightTrackerList({ dateOfBirth: dateOfBirthCopy });
            
        },
        async populateWeightTrackerList(details, isInitial = false){
            const { birthWeight, dateOfBirth, weightTracker} = details;

            if(!dateOfBirth) return;

            const birthWeightEntry = {
                id: 'birthWeight',
                litterId: '',
                status: '',
                weight: birthWeight || 0,
                unitsOfWeight: 'kg',
                entry: 'Birth Weight',
            }

            if(birthWeight){
                this.weightTrackerList.birthWeight = birthWeightEntry;
            }

            let daysWeek = 7; 
            let daysTracker = 0;

            for (const periodKey in this.weightTrackerList.periods) {
                const currentPeriod = this.weightTrackerList.periods[periodKey];

                const dateOfBirthCopy = new Date(dateOfBirth);
                dateOfBirthCopy.setDate(new Date(dateOfBirth).getDate());

                const notBeforeThisDate = new Date(dateOfBirthCopy);
                notBeforeThisDate.setDate(dateOfBirthCopy.getDate() + daysTracker);
                currentPeriod.notBeforeThisDate = notBeforeThisDate;

                daysTracker += daysWeek;

                const notAfterThisDate = new Date(dateOfBirthCopy);
                notAfterThisDate.setDate(dateOfBirthCopy.getDate() + daysTracker);
                currentPeriod.notAfterThisDate = notAfterThisDate;

                if(weightTracker && weightTracker[periodKey]){
                    currentPeriod.data = [...weightTracker[periodKey].data];
                    currentPeriod.data = currentPeriod.data.map(entryObj => ({...entryObj, weight: parseFloat(entryObj.weight || 0).toFixed(2), entry: new Date(entryObj.entry)}))
                }
            }

            if(isInitial){
                this.initialWeightTrackerList = JSON.parse(JSON.stringify(this.weightTrackerList));
            }

        },
        async getDamAndSireMatingDetails(matingId, litterId) {
            if (!matingId) {
                return;
            }

            try {
                // this.isAPILoading = true;
                const matingDetailsResponse =
                    await breedingManagementService.getDamAndSireMatingDetails(
                        "mating",
                        matingId
                    );

                if (matingDetailsResponse.status === STATUS_CODES.SUCCESS) {
                    const { data: matingDetails } = matingDetailsResponse;

                    this.damDetails = matingDetails.damDetails;
                    this.sireDetails = matingDetails.sireDetails;
                    this.matingName = matingDetails.alias;
                    this.littersCount = matingDetails.littersCount;
                    this.matingDetails = matingDetails;

                    if ( matingDetails.damDetails.whelpingDates &&  matingDetails.damDetails.whelpingDates.length > 0) {
                        const whelpingRecord = matingDetails.damDetails.whelpingDates.find(({ matingId }) => matingId == this.matingId);
                      
                        if(whelpingRecord){
                            const { typeOfBirth, whelpingDate } = whelpingRecord;
                            this.typeOfBirth = typeOfBirth;
                            this.whelpDate = whelpingDate ? new Date(whelpingDate) : null;

                     
                        }
                    }

                    const litterDetailsResponse =
                    await breedingManagementService.getDamAndSireLitterDetails(
                        litterId
                    );

                    if (litterDetailsResponse.status === STATUS_CODES.SUCCESS) {
                        this.puppyList.push(litterDetailsResponse.data)
                        
                        this.puppyList[0].dateOfBirth = this.puppyList[0].dateOfBirth ? new Date(this.puppyList[0].dateOfBirth): null
                        this.breed = this.breedList.find(breed => breed.id === this.puppyList[0].breedId);
                        this.puppyList[0].breed = this.breed

                        // set the birth weight
                        this.chartData.datasets[0].data[0] = litterDetailsResponse.data.birthWeight || 0;
                        this.weightProgressionPercentage.push(0);

                        let dateOfBirth = litterDetailsResponse.data.dateOfBirth ? new Date(litterDetailsResponse.data.dateOfBirth) : null;
                        if(dateOfBirth){
                            dateOfBirth.setDate(dateOfBirth.getDate() + 1); // add 1 to exclude the DOB on the first day datepicker
                        } else if(this.whelpDate){
                            dateOfBirth = this.whelpDate ? new Date(this.whelpDate) : null;
                            dateOfBirth.setDate(dateOfBirth.getDate() + 1); 
                        } else {
                            dateOfBirth = new Date(); // fallback to today
                        }

                        const details = { 
                            birthWeight: litterDetailsResponse.data ? litterDetailsResponse.data.birthWeight : 0, 
                            dateOfBirth, 
                            weightTracker: litterDetailsResponse.data.weightTracker
                        };
        
                        this.populateWeightTrackerList(details, true);

                        const noteHistory = litterDetailsResponse.data.litterNoteHistory;
                        if(noteHistory && noteHistory.length > 0){
                            this.puppyNotesHistory = noteHistory.filter(noteData => noteData.note !== "");
                            this.puppyNotes = noteHistory[0].note;

                            this.initialPuppyNotes = this.puppyNotes;
                        }
                     
                        this.initialPuppyList = JSON.parse(JSON.stringify(this.puppyList));

                    }
                    this.imageSrc = []
                    this.puppyList[0].images.forEach((img, i) => {
                        if (img.primary) {
                            this.setAsPrimary = i
                        }
                    })
                    this.imageSrc = this.puppyList[0].images
                    this.initialImageSrc = JSON.stringify(this.imageSrc);

                    const foundInitialImg = this.puppyList[0].images.find(imageData => imageData.primary);
                    this.initialPrimaryImage = foundInitialImg ? JSON.parse(JSON.stringify(foundInitialImg)) : null; // deep copy, removing reference
                } else {
                    const { ERROR_GET_MATING_DETAILS } =
                        this.toastMessages.mating();
                    this.showAPIErrorToast(
                        ERROR_GET_MATING_DETAILS,
                        matingDetailsResponse
                    );
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                // this.isAPILoading = false;
            }
        },
        computePercentageDifference(prevWeight, currentWeight) {
            // Check if either value is NaN
            if (isNaN(prevWeight) || isNaN(currentWeight)) {
                return 0;
            }

            const difference = currentWeight - prevWeight;
            const percentageDiff = (difference / prevWeight) * 100;

            return isFinite(percentageDiff) ? percentageDiff.toFixed(2) : 0;
        },
        removeImage(index, image) {
			this.isNewPuppyImage = true
			this.imageSrc.splice(index, 1)
			let isPrimaryImageDeleted = false

			if (parseInt(this.setAsPrimary) < 0) {
				this.setAsPrimary = 0
			} else if (parseInt(this.setAsPrimary) > parseInt(index)) {
				this.setAsPrimary = this.setAsPrimary - 1
			} else if (parseInt(this.setAsPrimary) === parseInt(index)) {
				this.setAsPrimary = 0
				isPrimaryImageDeleted = true
			}

			const isNewImage = !image.id //Newly added image
			if (!isNewImage) {
				this.deletedImages.push(image)
				this.copiedImages = this.imageSrc.filter((dt) => dt.id)

				if (isPrimaryImageDeleted) {
					if (this.imageSrc.length === 0) {
						this.updatedImages = []
						return
					}
					this.updatedImages = []
					this.updatedImages.push({ ...this.imageSrc[0], primary: true })
					if (this.copiedImages.length > 0) {
						this.copiedImages[0].primary = true
					} else {
						this.imageRef[0].primary = true
					}
				}
			} else {
				this.imageRef.splice(index, 1)
				this.filesToSend.splice(index, 1)
			}
		},
        notAfterDateOfBirth(date) {
            if(this.puppyList && this.puppyList[0].dateOfBirth){
                return date < this.puppyList[0].dateOfBirth;
            }
        },
        hasImageUrl(source){
            if(!source){
                return require('@/assets/images/_shared/dog-purchase.png');
            }

            return source;
        },
        sortAlphabetically(items) {
            const sortedItems = items.sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
            return sortedItems;
        },
        async getBreedList() {
            try {
                // this.isAPILoading = true;
                const breedsResponse = await breedService.getBreeds();

                if (breedsResponse.status === STATUS_CODES.SUCCESS) {
                    const otherBreedOptions = breedsResponse.data.data.slice(0, 4);
                    const breeds = this.sortAlphabetically(breedsResponse.data.data.slice(4, breedsResponse.data.count));

                    // remove "Breed not specified", it has id = 0
                    this.breedList = [...otherBreedOptions, ...breeds].filter(
                        (breed) => breed.id != 0
                    );
                } else {
                    const { ERROR_GET_BREED_LIST } = this.toastMessages.breed();
                    this.showAPIErrorToast(ERROR_GET_BREED_LIST, breedsResponse);
                }
            } catch (err) {
                this.showGenericErrorToast();
            } finally {
                // this.isAPILoading = false;
            }
        },
        notAfterToday(date) {
            const dateComparison = this.whelpDate ? new Date(this.whelpDate) : new Date();
            return date > dateComparison;
        },
        validateBirthWeight(event, index) {
            const field = event.target;
        
            setTimeout(() => {
                // Use the regex to match the pattern: digits followed by an optional decimal point and more digits
                // Example: it will match "123", "123.45", "0.5", and "123." (valid numbers with optional decimal part)
                const regex = /^\d*\.?\d*/;
        
                // Check if the field has a valid value (exists and is not null/undefined)
                if (field && field.value) {
                    // Execute the regex and check if a match was found
                    const match = regex.exec(field.value);
        
                    // If the match is found, use the first match; otherwise, set the value to an empty string
                    let sanitizedInput = match ? match[0] : '';
        
                    // Apply the sanitized input to the field
                    event.target.value = sanitizedInput;

                    this.chartData.datasets[0].data[0] = isNaN(parseFloat(sanitizedInput)) ? 0 : parseFloat(sanitizedInput)

                    // Set the sanitized value back to the model
                    // this.$set(this.puppyList[index], 'birthWeight', sanitizedInput);
                } else if (!field.value){
                    this.chartData.datasets[0].data[0] = 0;
                }

                this.chartData.datasets[0].data = [...this.chartData.datasets[0].data]; // force rerender
            }, 0);
        },
        beforeEnter(el) {
            el.style.opacity = 0;
          },
        enter(el, done) {
            el.offsetHeight; // trigger reflow
            el.style.transition = 'opacity 0.5s';
            el.style.opacity = 1;
             done();
        },
        leave(el, done) {
            el.style.transition = 'opacity 0.5s';
            el.style.opacity = 0;
            done();
        },
        compareDeepEqual(obj1, obj2) {
            if (obj1 === obj2) return true; // Check reference equality
        
            if (obj1 == null || obj2 == null || typeof obj1 !== 'object' || typeof obj2 !== 'object') {
                return false; // One is null or they are not both objects
            }
        
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
        
            if (keys1.length !== keys2.length) return false; // Different number of keys
        
            for (let key of keys1) {
                if (!keys2.includes(key) || !this.compareDeepEqual(obj1[key], obj2[key])) {
                    return false; // Key mismatch or nested value mismatch
                }
            }
        
            return true; // All keys and values match
        },
        togglePuppyCareInfo(){
            this.isPuppyCareInfoExpanded = !this.isPuppyCareInfoExpanded;
        },
    },
    
    async beforeRouteLeave(to, from, next) {
        const currentSelectedBreedId = this.breed ? this.breed.id : null;
        const initialBreedId = this.puppyList[0] && this.puppyList[0].breed ? this.puppyList[0].breed.id : null;

        const initialPrimaryImageId = this.initialPrimaryImage ? this.initialPrimaryImage.id : null;
        const currentPrimaryImageId = this.updatedImages.length ? this.updatedImages[0].id : initialPrimaryImageId;
      
        const isFormModified = JSON.stringify(this.puppyList) !== JSON.stringify(this.initialPuppyList);
        const isBreedModified = currentSelectedBreedId !== initialBreedId;
        const isPuppyNotesModified = this.puppyNotes.trim() !== this.initialPuppyNotes.trim();    
        const arePuppyImagesModified = (currentPrimaryImageId !== initialPrimaryImageId) || this.deletedImages.length > 0;    

        const areWeightsModified = JSON.stringify(this.weightTrackerList.periods) !== JSON.stringify(this.initialWeightTrackerList.periods);
        const isBirthWeightModified = (this.weightTrackerList.birthWeight.weight || "") !== (this.initialWeightTrackerList.birthWeight.weight || "");

        if(isBreedModified || isFormModified || areWeightsModified || isPuppyNotesModified || isBirthWeightModified || arePuppyImagesModified){
            const result = await this.showUnsavedChangesModal();

            if (result.value) {
                next(true);
            } else {
                next(false);
            }

        } else {
            next(true);
        }
    },

};
